function featuredCollection() {
	const featuredSections = document.querySelectorAll('.ie__featured');

	if (featuredSections) {
		featuredSections.forEach((el) => {
			const wrapper = el.querySelector('.ie__featured-wrapper');
			const gridItem = el.querySelector('.ie__grid-items');
			const prevEl = el.querySelector('.flickity-previous');
			const nextEl = el.querySelector('.flickity-next');
			const productCount = wrapper.dataset.productCount;

			if (productCount > 3) {
				const flkty = new Flickity(gridItem, {
					cellAlign: 'left',
					contain: true,
					draggable: false,
					wrapAround: true,
					prevNextButtons: false,
					pageDots: false,
					freeScroll: true,
				});

				prevEl.addEventListener('click', () => {
					flkty.previous();
				});

				nextEl.addEventListener('click', () => {
					flkty.next();
				});
			}
		});
	}
}

function animEffect() {
	const svgEl = document.querySelector('.effect-graphic svg');

	if (svgEl) {
		const dotsBg = svgEl.querySelector('#dots-bg'),
			diagram = svgEl.querySelector('#diagram'),
			axisY = svgEl.querySelector('#axis-y'),
			axisX = svgEl.querySelector('#axis-x'),
			letters = Array.from(svgEl.querySelectorAll('#effect-font path')),
			curveEnergy = svgEl.querySelector('#curve-energy'),
			curveEnergyLength = curveEnergy.getTotalLength() + 3,
			curveCoffe = svgEl.querySelector('#curve-cofee'),
			curveCoffeLength = curveCoffe.getTotalLength(),
			curveInfused = svgEl.querySelector('#curve-infused'),
			curveInfusedLength = curveInfused.getTotalLength(),
			scala = svgEl.querySelector('#scala'),
			coffee = svgEl.querySelector('#coffee'),
			energy = svgEl.querySelector('#energy'),
			infused = svgEl.querySelector('#infused'),
			coffeeIcon = svgEl.querySelector('.effect-graphic__details--coffee'),
			energyIcon = svgEl.querySelector('.effect-graphic__details--energy'),
			infusedIcon = svgEl.querySelector('.effect-graphic__details--infused'),
			scalaEnergy = svgEl.querySelector('.scala-energy'),
			scalaCoffee = svgEl.querySelector('.scala-coffee'),
			scalaInfused = svgEl.querySelector('.scala-infused'),
			mobileInfo = document.querySelector('.effect-graphic__mobile'),
			tl = gsap.timeline();

		gsap.set(curveEnergy, { strokeDasharray: curveEnergyLength });
		gsap.set(curveCoffe, { strokeDasharray: curveCoffeLength });
		gsap.set(curveInfused, { strokeDasharray: curveInfusedLength });

		tl.from(diagram, { scale: 0, duration: 1 })
			.from(axisX, { opacity: 0, x: -50, duration: 0.25 })
			.from(axisY, { opacity: 0, y: -50, duration: 0.25 })
			.from(dotsBg, { opacity: 0, duration: 1 })
			.from(scala, { opacity: 0, duration: 0.5 })
			.from(letters, { opacity: 0, duration: 1, stagger: 0.1 }, '=-1')
			.fromTo(curveEnergy, 1, { strokeDashoffset: curveEnergyLength }, { strokeDashoffset: 0 }, '=-1')
			.from(scalaEnergy, { opacity: 0, duration: 1 }, '=-.5')
			.from(energy, { scale: 0, duration: 0.5, ease: Back.easeOut }, '=-.5')
			.from(energyIcon, { opacity: 0, duration: 0.75 })
			.fromTo(curveCoffe, 1, { strokeDashoffset: curveCoffeLength }, { strokeDashoffset: 0 }, '=-1')
			.from(scalaCoffee, { opacity: 0, duration: 1 }, '=-0.5')
			.from(coffee, { scale: 0, duration: 0.25, ease: Back.easeOut }, '=-0.5')
			.from(coffeeIcon, { opacity: 0, duration: 0.75 })
			.fromTo(curveInfused, 1, { strokeDashoffset: curveInfusedLength }, { strokeDashoffset: 0 }, '=-1')
			.from(scalaInfused, { opacity: 0, duration: 1 }, '=-0.5')
			.from(infused, { scale: 0, duration: 0.25, ease: Back.easeOut }, '=-0.5')
			.from(infusedIcon, { opacity: 0, duration: 0.75 })
			.from(mobileInfo, { opacity: 0, duration: 0.75 });
	}
}

function closeDetails() {
	const details = document.querySelectorAll('details');

	if (details.length > 0) {
		details.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				details.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});
	}
}

function animSlider() {
	const sliderEls = Array.from(document.querySelectorAll('.ie__slides'));

	sliderEls.forEach((slider) => {
		const sliderText = Array.from(slider.querySelectorAll('.ie__slide-text > div'));
		const slide = Array.from(slider.querySelectorAll('.ie__slide'));
		const autoPlaySpeed = parseInt(slider.dataset.speed);
		const flkty = new Flickity(slider, {
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			wrapAround: true,
			autoPlay: autoPlaySpeed,
		});

		flkty.on('change', function (index) {
			const tl = gsap.timeline();
			tl
				.from(slide, { scale: 1.4, duration: 0.4, ease: Power1.easeOut })
				.fromTo(sliderText, { opacity: 0, x: 100 }, { opacity: 1, x: 0, stagger: 0.2, ease: Power2.easeOut }),
				'=-2';
		});

		// Add a delay to allow the slider to initialize before resizing it
		setTimeout(() => {
			flkty.resize();
		}, 1000);
	});
}

// Add a window event listener to resize the slider whenever the window is resized
window.addEventListener('resize', function () {
	const sliders = document.querySelectorAll('.ie__slides');
	sliders.forEach((slider) => {
		const flkty = Flickity.data(slider);
		setTimeout(() => {
			flkty.resize();
		}, 100);
	});
});

function animCompare() {
	const sliderEl = document.querySelector('.compare__overlay');

	if (sliderEl) {
		const sliderText = Array.from(sliderEl.querySelectorAll('.compare__details'));
		const leftSlides = Array.from(sliderEl.querySelectorAll('.compare__left'));
		const autoPlaySpeed = parseInt(sliderEl.dataset.speed);

		const flkty = new Flickity(sliderEl, {
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			wrapAround: true,
			draggable: true,
			autoPlay: autoPlaySpeed,
			fade: true,
		});

		flkty.on('change', function (index) {
			const tl = gsap.timeline();
			tl
				.from(leftSlides, { scale: 1.4, duration: 0.4, ease: Power1.easeOut })
				.fromTo(sliderText, { opacity: 0, x: 100 }, { opacity: 1, x: 0, stagger: 0.2, ease: Power2.easeOut }),
				'=-2';
		});
	}
}

function colorHeader() {
	const headerEl = document.querySelector('.template-page-contact #HeaderWrapper');
	if (headerEl) {
		headerEl.classList.remove('is-light');
	}
}

function dynamicSlider() {
	const galleryContainer = document.querySelector('.dynamic__slider-container'),
		galleryCtrls = document.querySelector('.dynamic__slider-controls'),
		galleryCtrlsBtns = ['previous', 'next'];

	if (galleryContainer) {
		let intActive = 0;

		class Carousel {
			constructor(container, controls) {
				this.carouselContainer = container;
				this.carouselControls = controls;
				this.items = container.children;
				this.carouselArray = [...this.items];
				this.count = this.carouselArray.length;
				if (this.count < 5) {
					let intRequired = Math.round(5 / this.count);
					for (var i = 0; i < intRequired - 1; i++) {
						Array.prototype.forEach.call(this.carouselArray, (item) => {
							galleryContainer.insertAdjacentHTML('beforeend', item.outerHTML);
						});
					}
					this.carouselArray = [...this.items];
					this.count = this.carouselArray.length;
				}
				this.dragStart = 0;
			}

			initDragEvents() {
				this.carouselContainer.addEventListener('mousedown', this.dragStartHandler.bind(this));
				this.carouselContainer.addEventListener('mousemove', this.dragMoveHandler.bind(this));
				this.carouselContainer.addEventListener('mouseup', this.dragEndHandler.bind(this));
				this.carouselContainer.addEventListener('mouseleave', this.dragEndHandler.bind(this));

				this.carouselContainer.addEventListener('touchstart', this.dragStartHandler.bind(this));
				this.carouselContainer.addEventListener('touchmove', this.dragMoveHandler.bind(this));
				this.carouselContainer.addEventListener('touchend', this.dragEndHandler.bind(this));
			}

			dragStartHandler(e) {
				e.preventDefault();
				if (e.touches) {
					this.dragStart = e.touches[0].clientX;
				} else {
					this.dragStart = e.clientX;
				}
			}

			dragMoveHandler(e) {
				let clientX;
				if (e.touches) {
					clientX = e.touches[0].clientX;
				} else {
					clientX = e.clientX;
				}
				if (this.dragStart === 0) return;
				const deltaX = clientX - this.dragStart;
				if (Math.abs(deltaX) > 50) {
					if (deltaX > 0) {
						this.setActive(true);
					} else {
						this.setActive();
					}
					this.dragStart = 0;
				}
			}

			dragEndHandler(e) {
				this.dragStart = 0;
			}

			setActive(prev = false) {
				if (prev) {
					intActive === 0 ? (intActive = this.count - 1) : intActive--;
				} else {
					intActive === this.count - 1 ? (intActive = 0) : intActive++;
				}
				Array.prototype.forEach.call(this.carouselArray, (item) => {
					item.setAttribute('state', 'inactive');
				});
				this.carouselArray[this.stateVal(intActive, 'first')].setAttribute('state', 'first');
				this.carouselArray[this.stateVal(intActive, 'previous')].setAttribute('state', 'previous');
				this.carouselArray[intActive].setAttribute('state', 'selected');
				this.carouselArray[this.stateVal(intActive, 'next')].setAttribute('state', 'next');
				this.carouselArray[this.stateVal(intActive, 'last')].setAttribute('state', 'last');
			}

			stateVal(int, type) {
				switch (type) {
					case 'first':
						if (int < 1) {
							int = this.count - 1 - 1;
						} else if (int < 2) {
							int = this.count - 1;
						} else {
							int -= 2;
						}
						break;
					case 'previous':
						int < 1 ? (int = this.count - 1 - int) : int--;
						break;
					case 'next':
						this.count - 1 - int < 1 ? (int = 0) : int++;
						break;
					case 'last':
						if (this.count - 1 - int < 1) {
							int = 1;
						} else if (this.count - 1 - int < 2) {
							int = 0;
						} else {
							int += 2;
						}
						break;
					default:
				}
				return int;
			}

			setControls() {
				this.carouselControls.forEach((control) => {
					galleryCtrls.appendChild(
						document.createElement('button')
					).className = `gallery-controls-${control}`;
				});
			}

			useControls() {
				const triggers = [...galleryCtrls.childNodes];

				triggers.forEach((control, index) => {
					control.addEventListener('click', () => {
						if (this.carouselControls[index] === 'previous') {
							exampleCarousel.setActive(true);
						} else {
							exampleCarousel.setActive();
						}
					});
				});
			}
		}

		const exampleCarousel = new Carousel(galleryContainer, galleryCtrlsBtns);

		exampleCarousel.setControls();
		exampleCarousel.useControls();
		exampleCarousel.setActive();
		exampleCarousel.initDragEvents();
	}
}

function productSlider() {
	const productSlider = document.querySelector('.product-block--slider');

	if (productSlider) {
		const flkty = new Flickity(productSlider, {
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			autoPlay: 3000,
			lazyLoad: true,
		});

		window.addEventListener('flickity:slide', (e) => {
			flkty.select(e.detail.index);
		});

		imagesLoaded(productSlider, function () {
			flkty.resize();
		});
	}
}

function mobileRedirect() {
	if (window.innerWidth <= 800 && window.location.pathname === '/collections/shop-landing-page') {
		window.location.replace('/?openMenu=true');
	}

	window.addEventListener('load', function () {
		if (window.innerWidth <= 800 && window.location.search.includes('openMenu=true')) {
			const button = document.querySelector('.js-drawer-open-nav');

			button.click();

			setTimeout(function () {
				const menuItem = document.querySelector('.drawer__contents .collapsible-trigger');

				menuItem.click();
			}, 500);
		}
	});
}

function init() {
	featuredCollection();
	animEffect();
	closeDetails();
	animSlider();
	animCompare();
	colorHeader();
	dynamicSlider();
	productSlider();
	mobileRedirect();
}

document.addEventListener('DOMContentLoaded', init, false);

document.addEventListener("DOMContentLoaded", function () {

    // ----------------- CP Quick ATC Functionality --------------------
        // document.querySelectorAll(".product_card_atc").forEach(button => {
        //     button.addEventListener("click", function () {
        //         let product_id = this.getAttribute("product_id");
        //         let clickedButton = this; 
        //         clickedButton.classList.add("btn_loading");
    
        //         const data = {
        //             id: product_id,
        //             quantity: 1
        //         };
    
        //         fetch("/cart/add.js", {
        //             method: "POST",
        //             headers: {
        //                 "Content-Type": "application/json"
        //             },
        //             body: JSON.stringify(data)
        //         })
        //         .then(response => response.json())
        //         .then(response => {
        //             window.location.href = '/cart';
        //             clickedButton.classList.remove("btn_loading");
        //             // clickedButton.classList.add("active_btn");
        //             // setTimeout(() => {
        //             //     clickedButton.classList.remove("active_btn");
        //             // }, 2000);
        //         })
        //         .catch(error => {
        //             console.error("Error adding product to cart:", error);
        //         });
        //     });
        // });

      // -------------- Price Per Litre ----------------------
      var pricePerItems = document.querySelectorAll('.price_per_litre_item');
      if (pricePerItems.length > 0) {
              document.addEventListener("variant:change", function () {
                setTimeout(function(){
                    var variantSelect = document.querySelector('[data-product-select]');
                    if (variantSelect) {
                        var variantId = variantSelect.value;
  
                        pricePerItems.forEach(function (item) {
                            item.style.display = "none";
                        });
                        var selectedItem = document.querySelector('.price_per_litre_item[per_litre_id="' + variantId + '"]');
                        if (selectedItem) {
                            selectedItem.style.display = "block";
                        }
                    }
                },300);
              });
          }

  // -------------- Shipping Progress Bar ----------------------
    document.addEventListener("cart:updated", async function () {
        setTimeout(async function () {
            const cartFreeShipping = document.querySelector('.cart_free_shipping');
            if (!cartFreeShipping) return;
            
            try {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                const cartTotal = cart.total_price;
                const shippingThreshold = parseFloat(cartFreeShipping.getAttribute('shipping_threshold')) || 0;
                const currency = cartFreeShipping.getAttribute('currency') || '';
                
                const freeShippingRemainingText = cartFreeShipping.querySelector('.free_shipping_remaing_text');
                const freeShippingReachedText = cartFreeShipping.querySelector('.free_shipping_reached_text');
                const shippingIcon = cartFreeShipping.querySelector('.shipping__icon');
                const progressBar = cartFreeShipping.querySelector('.progress_bar');
                const remainingThreshold = cartFreeShipping.querySelector('.remaining_threshold');
                
                if (cartTotal >= shippingThreshold) {
                    freeShippingRemainingText.style.display = 'none';
                    freeShippingReachedText.style.display = 'block';
                    shippingIcon.classList.add('active');
                    progressBar.style.width = '100%';
                } else {
                    const progress = ((cartTotal * 100) / shippingThreshold).toFixed(2);
                    progressBar.style.width = `${progress}%`;
                    remainingThreshold.innerText = `${((shippingThreshold - cartTotal)/100).toFixed(2)} ${currency}`;
                    freeShippingRemainingText.style.display = 'block';
                    freeShippingReachedText.style.display = 'none';
                    shippingIcon.classList.remove('active');
                }
    
                cartFreeShipping.style.display = cartTotal === 0 ? 'none' : 'block';
            } catch (error) {
                console.error("Error fetching cart data:", error);
            }
        }, 300);
    });

    //--------------------- PDP ATC Nofitication POPUP -----------------
          // Check if the 'atc_notification_btn' exists
          if (document.querySelectorAll('.atc_notification_btn').length > 0) {
          
              const popup = document.querySelector('.atc_notification_popup');
              
              // Add event listener for each 'atc_notification_btn'
              document.querySelectorAll('.atc_notification_btn').forEach(function(button) {
                  button.addEventListener('click', async function() {
                      // Find the closest product block and get the variant ID (product ID)
                      const productId = this.closest('.product-block').querySelector('[name="id"]').value;
                      const duration = parseInt(this.getAttribute('notification_duration'));
              
                      // Create the data object for the POST request
                      const data = {
                          items: [{
                              id: productId,
                              quantity: 1
                          }]
                      };
              
                      try {
                          // Send the POST request to add the item to the cart
                          const response = await fetch('/cart/add.js', {
                              method: 'POST',
                              headers: {
                                  'Content-Type': 'application/json',
                                  'Accept': 'application/json',
                              },
                              body: JSON.stringify(data),
                          });
          
                          const result = await response.json();
                          if (response.ok) {
                              // Set the product image in the notification popup
                              document.querySelector('.notification_product_img img').setAttribute('src', result.items[0].image);
                              
                              // Add the 'active_popup' class to show the notification
                              popup.classList.add('active_popup');
          
                              // After 3 seconds, remove the 'active_popup' class
                              setTimeout(function() {
                                  popup.classList.remove('active_popup');
                              }, duration);
                          } else {
                              console.error('Error adding item to cart:', result);
                          }
                      } catch (error) {
                          console.error('Failed to add item to cart:', error);
                      }
                  });
              });
          
              // Close the popup when the close button is clicked
              document.querySelector('.pdp_notification_close').addEventListener('click', function() {
                  popup.classList.remove('active_popup');
              });
          }
  
});
